/**
 * Create a cache key from an array of strings
 * @param {string} typename the __typename of the object
 * @param {string[]} list the list of strings
 * @returns {string} a cache key
 */
export const cacheKeyFromArray = (typename: string, list: string[]): string =>
    `${typename}:${list.sort().join('.')}`;
